module.exports = "/packs/media/images/brands/betterment-b5daac9d08f6e1f666be9a334bcfbcb7.png";